import type { GenieKnowledgeEntry } from '../../types';

export const gbs: GenieKnowledgeEntry = {
  id: 'gbs',
  aliases: ['acute_axonal_neuropathy', 'demyelinating_neuropathy'],
  name: 'Síndrome de Guillain-Barré',
  category: 'neuropatico',
  conversation: {
    headline:
      'Polirradiculoneuropatía inflamatoria aguda. Las NCS de la primera semana pueden ser normales; repetir a los 10–14 días.',
    edxHighlights: [
      'Ondas F ausentes/prolongadas: hallazgo más temprano (día 1–3)',
      'Sural sparing: SNAPs MS ausentes con sural normal (>90% especificidad AIDP)',
      'Semana 2–3: criterios desmielinizantes completos (VCM, LMD, bloqueos)',
      'AMAN: CMAPs ↓ con velocidades normales y SNAPs conservados',
    ],
    pearls: [
      'NCS normales en semana 1 NO descartan GBS — repetir estudio.',
      'CMAP distal <20% LIN a los 3–7 días sugiere daño axonal y peor pronóstico.',
    ],
    differentials: [
      { name: 'CIDP', distinguishingHint: 'curso crónico (>8 sem), no agudo ascendente' },
      { name: 'AMAN', distinguishingHint: 'axonal puro, anti-GM1, Campylobacter previo' },
    ],
    nextSteps: [
      'Correlacionar con arreflexia y debilidad ascendente',
      'Si NCS iniciales normales, programar repetición a 10–14 días',
    ],
  },
  detail: {
    summary:
      'Espectro con variantes desmielinizantes (AIDP, 85–90%) y axonales (AMAN/AMSAN). Precedido por infección en 60–70%.',
  },
  orientationHints: {
    temporalFit: ['acute', 'subacute'],
    whenToSuspect: 'Debilidad ascendente aguda + arreflexia tras infección reciente',
  },
};
